import { useEffect, useState } from 'react';

interface UseFilterProps<T> {
  items: T[];
  criteria: Array<
    (item: T, selectedFilters: { [group: string]: string[] }) => boolean
  >;
  initialFilters?: { [group: string]: string[] };
}

function useFilter<T>({
  items,
  criteria,
  initialFilters = {},
}: UseFilterProps<T>) {
  const [selectedFilters, setSelectedFilters] = useState<{
    [group: string]: string[];
  }>(initialFilters);
  const [filteredItems, setFilteredItems] = useState<T[]>(items);

  useEffect(() => {
    const filtered = items.filter((item) =>
      criteria.every((criterion) => criterion(item, selectedFilters)),
    );
    setFilteredItems(filtered);
  }, [items, criteria, selectedFilters]);

  const handleTagChange = (group: string, tag: string, checked: boolean) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [group]: checked
        ? [...(prevFilters[group] ?? []), tag]
        : (prevFilters[group] ?? []).filter((t) => t !== tag),
    }));
  };

  return {
    filteredItems,
    selectedFilters,
    handleTagChange,
  };
}

export { useFilter };
